import { CoreExecutorResult, } from "../../core/index.js";
import { PimClass } from "../model/index.js";
import { PimExecutorResultFactory } from "./pim-executor-utils.js";
export async function executePimSetExtends(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.pimResource);
    if (resource == null) {
        return CoreExecutorResult.createError(`Missing pim resource '${operation.pimResource}'.`);
    }
    if (!PimClass.is(resource)) {
        return CoreExecutorResult.createError("Invalid resource type.");
    }
    for (const extendsClass of operation.pimExtends) {
        const cls = await reader.readResource(extendsClass);
        if (!PimClass.is(cls)) {
            return PimExecutorResultFactory.invalidType(cls, "pim:class");
        }
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            pimExtends: operation.pimExtends,
        },
    ]);
}
//# sourceMappingURL=pim-set-extends-executor.js.map